<template>
  <div v-bem>
    <div v-bem:content="{panorama: type === 'panorama'}">
      <span v-bem:close @click="$emit('close-clicked')">&times;</span>
      <template v-if="type !== 'panorama'">
        <div class="popin-form">
          <div v-if="submitStatus !== 'SENT'">
            <p v-bem:title>{{$t(`form.${type}.title`)}}</p>
            <div v-bem:car>
              <p>{{$t('form.test-drive.you-select')}} <strong>{{model.nom}}</strong></p>
            </div>
            <p v-bem:title><span>{{$t(`form.${type}.sub-title`)}}</span></p>
          </div>
          <div v-bem:confirm v-if="submitStatus === 'SENT'">
            <div class="intro"><img src="@/assets/img/icons/confirm-green.svg" alt=""></div>
            <div class="content"><p>{{$t('form.sent')}}</p></div>
          </div>
          <Loader v-if="submitStatus === 'PENDING'" />
          <form @submit.prevent="submit" class="row form" v-if="submitStatus !== 'SENT' && submitStatus !== 'PENDING'">
            <div class="col-6 col-m-6">
              <div class="form-control">
                <input
                  v-model="$v.user.lastname.$model"
                  type="text"
                  name="lastname"
                  :class="{error: $v.user.lastname.$dirty && $v.user.lastname.$invalid}"
                  :placeholder="`${$t('form.lastname')} *`"
                >
                <div class="errors" v-if="$v.user.lastname.$dirty">
                  <p v-if="!$v.user.lastname.required">{{$t('form.error.required.lastname')}}</p>
                  <p v-if="!$v.user.lastname.custom_alpha">{{$t('form.error.lettres.lastname')}}</p>
                  <p v-if="!$v.user.lastname.minLength">{{$t('form.error.min.lastname')}}</p>
                  <p v-if="!$v.user.lastname.maxLength">{{$t('form.error.max.lastname')}}</p>
                </div>
              </div>
            </div>
            <div class="col-6 col-m-6">
              <div class="form-control">
                <input
                  v-model="$v.user.firstname.$model"
                  type="text"
                  name="firstname"
                  :class="{error: $v.user.firstname.$dirty && $v.user.firstname.$invalid}"
                  :placeholder="`${$t('form.firstname')} *`"
                >
                <div class="errors" v-if="$v.user.firstname.$dirty">
                  <p v-if="!$v.user.firstname.required">{{$t('form.error.required.firstname')}}</p>
                  <p v-if="!$v.user.firstname.custom_alpha">{{$t('form.error.lettres.firstname')}}</p>
                  <p v-if="!$v.user.firstname.minLength">{{$t('form.error.min.firstname')}}</p>
                  <p v-if="!$v.user.firstname.maxLength">{{$t('form.error.max.firstname')}}</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-control">
                <input
                  v-model="$v.user.email.$model"
                  type="email"
                  name="email"
                  :class="{error: $v.user.email.$dirty && $v.user.email.$invalid}"
                  :placeholder="`${$t('form.email')} *`"
                >
                <div class="errors" v-if="$v.user.email.$dirty">
                  <p v-if="!$v.user.email.required">{{$t('form.error.required.email')}}</p>
                  <p v-if="!$v.user.email.custom_email">{{$t('form.error.valid.email')}}</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-control">
                <input
                  v-model="$v.user.phone.$model"
                  type="tel"
                  name="phone"
                  :class="{error: $v.user.phone.$dirty && $v.user.phone.$invalid}"
                  :placeholder="`${$t('form.phone')} *`"
                >
                <div class="errors" v-if="$v.user.phone.$dirty">
                  <p v-if="!$v.user.phone.required">{{$t('form.error.required.phone')}}</p>
                  <p v-if="!$v.user.phone.custom_phone">{{$t('form.error.valid.phone')}}</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-control checkbox" :class="{error: $v.user.terms.$dirty && $v.user.terms.$invalid}">
                <label>{{$t('notices.terms')}} <a :href="`https://www.succursalesdacia.ma/${$i18n.locale}/pages/informations_legales`" target="_blank">{{$t('notices.terms-link')}}</a> *
                  <input v-model="$v.user.terms.$model" type="checkbox" name="terms" @change="$v.user.terms.$touch()">
                  <span></span>
                </label>
              </div>
              <div class="errors" v-if="$v.user.terms.$dirty">
                <p v-if="!$v.user.terms.sameAs">{{$t('form.error.required.terms')}}</p>
              </div>
              <div class="text-center">
                <div class="errors">
                  <p class="text-center" v-if="submitStatus === 'SUBMIT_ERROR'">{{$t('form.error.send')}}</p>
                </div>
                <button type="submit" class="button button--primary"><span class="button__text">
                  {{$t(type === 'brochure' ? 'cta.download-flyer' : 'cta.send')}}
                </span></button>
                <div class="asterisks">
                  <p>{{$t('notices.required')}}</p>
                  <p v-html="$t('notices.law')"></p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </template>
      <template v-else>
        <div class="tabs">
          <p v-for="tab in tabs" :key="tab.id" :class="['tab', {active: tab.id === activeTab}]">
            <span @click="activeTab = tab.id">{{tab.label}}</span>
          </p>
        </div>
        <div>
          <div v-bem:car><p>{{$t('form.test-drive.you-select')}} <strong>{{model.nom}}</strong></p></div>
          <div v-if="activeTab === 'exterior'">
            <p v-bem:title><span>{{$t('steps.exterior.title')}}</span></p>
            <div v-bem:preview class="exterior">
              <vue-three-sixty 
                spinReverse
                :amount="24"
                :imagePath="`https://www.succursalesrenault.ma/onlinestore/360ext/${model.nom_lien.toLowerCase()}/${colorCode}`"
                fileName="{index}.jpeg"
              />
            </div>
            <div class="text-center"><p class="notice">{{$t('notices.images')}}</p></div>
          </div>
          <div v-if="activeTab === 'interior'">
            <p v-bem:title><span>{{$t('steps.interior.title')}}</span></p>
            <div v-bem:preview class="interior">
              <iframe
                title="interior"
                :src="`/onlinestore/three-sixty/interior/?image=${interior}`"
                frameBorder="0"
              ></iframe>
              <div class="text-center"><p class="notice">{{$t('notices.images')}}</p></div>
            </div>
          </div>
          <div v-if="activeTab === 'gallery'">
            <p v-bem:title><span>{{$t('steps.gallery.title')}}</span></p>
            <slick v-bem:carousel="{rtl: $i18n.locale === 'ar'}" :options="carouselOptions">
              <div v-bem:carousel:item v-for="(gallery, index) in model.gallerys" :key="'gallery_'+index" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                <img :src="gallery.image">
              </div>
            </slick>
            <div class="text-center"><p class="notice">{{$t('notices.images')}}</p></div>
          </div>
          <div v-if="activeTab === 'video'">
            <p v-bem:title><span>{{$t('steps.video.title')}}</span></p>
            <div class="video">
              <video width="320" height="240" controls>
                <source :src="model.video" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import axios from 'axios'
import Slick from 'vue-slick'
import { helpers, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
const custom_alpha = helpers.regex('custom_alpha', /^[a-zA-Z ]+$/)
const custom_email = helpers.regex('custom_email', /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
const custom_phone = helpers.regex('custom_phone', /^((05)|(06)|(07))[0-9]{8}$/)

export default {
  props: ['type'],
  name: 'Popin',
  components: {
    Loader: () => import('@/components/Loader.vue'),
    Slick
  },
  mixins: [validationMixin],
  data: () => ({
    activeTab: 'exterior',
    brand: process.env.VUE_APP_THEME,
    submitStatus: '',
    user :{
      lastname : '',
      firstname: '',
      phone    : '',
      email    : '',
      terms    : ''
    },
    carouselOptions: {
      prevArrow   : '<button type="button" class="slick-prev">&#10094;</button>',
      nextArrow   : '<button type="button" class="slick-next">&#10095;</button>',
      slidesToShow: 1
    }
  }),
  validations: {
    user : {
      lastname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      firstname: {
        required,
        custom_alpha,
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      phone: {
        required,
        custom_phone,
      },
      email: {
        required,
        custom_email,
      },
      terms: { sameAs: sameAs( () => true ) }
    }
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) this.submitStatus = 'ERROR'
      else {
        this.submitStatus  = 'PENDING'
        axios.post(`https://succursalesrenault.ma/onlinestore/admin/public/api/popup-form`, {
          ...this.user,
          model   : this.model.nom_lien.toLowerCase(),
          version : this.version ? this.version.nom_version : '',
          type    : this.type,
          source  : this.utm.source,
          campaign: this.utm.campaign
        })
          .then(({status}) => {
            if (status === 200 || status === 201) {
              let storeUser = localStorage.getItem('storeUser')
              storeUser = storeUser ? JSON.parse(storeUser) : {}
              localStorage.setItem('storeUser', JSON.stringify({
                ...storeUser,
                lastname : this.user.lastname,
                firstname: this.user.firstname,
                phone    : this.user.phone,
                email    : this.user.email
              }))
              let type_demande = '';
              if (this.type === 'test-drive') type_demande = 'Test drive Onlinestore';
              if (this.type === 'brochure') type_demande = 'Brochure Onlinestore';
              const date = new Date()
              const params = new URLSearchParams()
              params.append('civilite', '')
              params.append('nom', this.user.lastname)
              params.append('prenom', this.user.firstname)
              params.append('telephone', this.user.phone)
              params.append('email', this.user.email)
              params.append('modele', this.model.nom_lien.toLowerCase())
              params.append('type_demande', type_demande)
              params.append('Date_demande', date.toISOString())
              params.append('priorite', '')
              params.append('Nom_compagne', this.utm.campaign)
              params.append('campagne', this.utm.campaign)
              params.append('content', this.utm.content)
              params.append('origin', this.utm.source)
              params.append('appelvideo', '')
              params.append('reprise', '')
              params.append('PassKey', process.env.VUE_APP_TELUS_KEY)
              window.telus.post('/Save_Ld_CB.php', params)
                .then(({status}) => {
                  if (status === 200 || status === 201) {
                    gtag('event', 'conversion', {'send_to': 'AW-774209629/U0ebCOCE1OEBEN2AlvEC'})
                    if (this.type === 'test-drive') this.submitStatus = 'SENT'
                    else {
                      this.$emit('close-clicked')
                      window.open(this.model.brochure_modele, '_blank')
                    }
                  }
                  else this.submitStatus = 'SUBMIT_ERROR'
                })
                .catch(err => {
                  this.submitStatus = 'SUBMIT_ERROR'
                  console.error(err)
                })
            }
          })
          .catch(err => {
            this.submitStatus = 'SUBMIT_ERROR'
            console.error(err)
          })
      }
    }
  },
  computed: {
		...mapGetters([
      'model',
      'version',
      'color',
      'utm'
    ]),
    interior() {
      if (this.version) {
        if (this.version['360_exist'] == 1) return `https://www.succursalesrenault.ma/onlinestore/360/${this.model.nom_lien.toLowerCase()}/${this.version.nom_version}/360.jpg`
        return null
      } else {
        let version
        version = this.model.voitures.findIndex(item => item['360_exist'] == 1)
        if (version === -1) return null
        return `https://www.succursalesrenault.ma/onlinestore/360/${this.model.nom_lien.toLowerCase()}/${this.model.voitures[version].nom_version}/360.jpg`
      }
    },
    tabs() {
      const tabs = [{ id: 'exterior', label: this.$t('tabs.exterior') }]
      if (this.interior) tabs.push({ id: 'interior', label: this.$t('tabs.interior') })
      if (this.model.gallerys.length > 0) tabs.push({ id: 'gallery', label: this.$t('tabs.gallery') })
      if (this.model.video) tabs.push({ id: 'video', label: this.$t('tabs.video') })
      return tabs
    },
    colorCode() {
      return this.color ? this.color.code_couleur : this.model.couleurs[0].code_couleur
    }
    // images() {
    //   return [...Array(24)].map((_, index) => `https://www.succursalesrenault.ma/onlinestore/360ext/${this.model.nom_lien.toLowerCase()}/${this.colorCode}/${index+1}.jpeg`)
    // }
  },
  created() {
    let storeUser = localStorage.getItem('storeUser')
    storeUser = storeUser ? JSON.parse(storeUser) : {}
    this.user = {...this.user, ...storeUser}
  }
}
</script>

<style lang="scss">
.popin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999999999;
  background-color: rgba($black, 0.7);
  &__content {
    @extend %transform-center;
    background-color: $white;
    width: 95%;
    max-width: rem(560);
    padding: rem(30) rem(4);
    &--panorama {
      max-width: rem(760);
    }
    .popin-form {
      max-width: rem(520);
      margin: 0 auto;
    }
  }
  &__close {
    position: absolute;
    top: rem(4);
    right: rem(12);
    @include font-size(22);
    font-weight: bold;
    cursor: pointer;
  }
  &__title {
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    @include font-size(22);
    margin-bottom: rem(4);
    span {
      display: block;
      color: $dark-gray;
      @include font-size(14);
      font-weight: normal;
      text-transform: initial;
      max-width: rem(360);
      margin: rem(4) auto rem(16);
    }
  }
  &__car {
    text-align: center;
    @include font-size(18);
    strong {
      @include font-size(22);
      display: block;
      color: rgba(var(--primary-color), 1);
      text-transform: uppercase;
      font-family: var(--primary-font-bold);
    }
    img {
      max-width: rem(260);
    }
  }
  &__confirm {
    text-align: center;
    padding: rem(48) rem(24);
    .intro {
      margin-bottom: rem(16);
      img {
        max-width: rem(60);
      }
    }
    .content {
      p {
        strong {
          font-family: var(--primary-font-bold) !important;
        }
      }
    }
  }
  .tabs {
    max-width: rem(520);
    margin: rem(16) auto;
    padding: 0 rem(8);
    .tab {
      display: inline-block;
      text-align: center;
      font-family: var(--primary-font);
      border-bottom: rem(2) solid $white;
      span {
        cursor: pointer;
        padding-bottom: rem(2);
        @include font-size(14);
        line-height: 1;
      }
      &.active {
        font-family: var(--primary-font-bold);
        span {
          border-bottom: rem(2) solid rgba(var(--primary-color), 1);
        }
      }
    }
    @for $i from 1 through 4 {
      p:first-child:nth-last-child(#{$i}) {
        width: percentage(1 / $i);
        & ~ p {
          width: percentage(1 / $i);
        }
      }
    }
  }
  &__preview {
    &.exterior {
      max-width: rem(598);
      margin: 0 auto;
    }
    &.interior {
      iframe {
        width: 100%;
        height: rem(420);
        margin: 0 auto;
      }
    }
  }
  &__carousel {
    padding: 0 rem(8);
    .slick-prev {
      left: rem(16);
    }
    .slick-next {
      right: rem(16);
    }
    .slick-prev,
    .slick-next {
      color: $white;
      text-shadow: 0 0 rem(4) rgba($black, 0.7);
    }
    &--rtl {
      direction: ltr;
      .slick-prev {
        right: unset;
        left: rem(16);
      }
      .slick-next {
        left: unset;
        right: rem(16);
      }
    }
  }
  .video {
    max-width: rem(970);
    margin: 0 auto;
    padding: 0 rem(8);
    video {
      width: 100%    !important;
      height: auto   !important;
      background-color: black;
    }
  }
  @include breakpoint('charmander') {
    &__preview {
      &.interior {
        iframe {
          height: rem(300);
        }
      }
    }
  }
}
</style>